export interface IAuthInterface {
    username: string;
    password: string;
}

export interface ISignUpInterface {
    username: string;
    phone: string;
    firstName: string;
    lastName: string;
    password: string;
}

export interface ISetPasswordInterface {
    password: string;
    confirmPassword: string;
}

export interface ILoginResponse {
    access_tokens: IRefreshTokenResponse[];
}

export interface IRefreshTokenResponse {
    user_id: string;
    access_token: string;
    expires_in: number;
    refresh_token: string;
    scope: string;
    token_type: string;
    flow?: string;
}

interface IAdmin {
    first_name: string;
    last_name: string;
    email: string;
    mobile: string;
    id: string;
    roles: string[];
    status: string;
    verified_mobile: string;
    verified_email: string;
    created: string;
    modified: string;
    two_fa_required: boolean;
}

interface ICustomToken {
    token: string;
    provider: string;
    scopes: string[];
}

export interface IAuthResponse {
    id: string;
    flow: string;
    admin_id?: string;
    admin?: IAdmin;
    custom_token?: ICustomToken;
}

export interface IResetPassword {
    mobile: string;
    password_type: 'PASSCODE' | 'PASSWORD';
}
